import { Component } from '@angular/core';
import { marker as _ } from '@biesbjerg/ngx-translate-extract-marker';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { simpleDeepClone } from '@phx-erp/shared';
import { NotificationService } from '../../../../../@core/services/notification/notification.service';
import { AssetInput, UserInput } from '../../../../../generated/generated-types';
import { AuthService } from '../../../../../shared/services/auth.service';
import { UserService } from '../../../../../shared/services/user-service.service';
import { AssetService } from '../../../../asset/services/asset.service';
import { WidgetAssetPreviewComponent } from '../../../../asset/widget-asset-preview/widget-asset-preview.component';


@Component({
  selector: 'app-user-featured-asset-widget',
  templateUrl: './user-featured-asset-widget.component.html',
  standalone: true,
  imports: [
    WidgetAssetPreviewComponent
  ]
})
export class UserFeaturedAssetWidgetComponent extends FieldType<FieldTypeConfig> {

  constructor(
    private assetService: AssetService,
    private userService: UserService,
    private authService: AuthService,
    private notificationService: NotificationService,
  ) {
    super();
  }

  async onFilesSelected(files: File[]) {

    if (files?.length == 1) {

      let currentUser = this.authService.getCurrentUser();
      let user = await this.userService.getItemData(currentUser.id)
      user = simpleDeepClone(user);

      let input: AssetInput = {
        file: files[0],
        name: "test"
      }

      let res = await this.assetService.saveAsset(input);

      let updateUser: UserInput = {
        id: user.id,
        featuredAssetId: res.id
      }

      await this.userService.saveItem(updateUser);
      this.notificationService.success(_("common.save-successful"));
      this.formControl.setValue(res);
    }
  }

  getAsset(key: string | number | (string | number)[]) {
    if (this.model && this.model.user) {

      // return this.model.user.featuredAsset; //direct solution but not flexible

      let currentKey = key as string;

      if (currentKey.includes(".")) {
        let keySplitArray = currentKey.split(".");
        let realValue;
        for (let i = 0; i < keySplitArray.length; i++) {
          let key = keySplitArray[i];
          if (realValue) {
            realValue = realValue[key as string];
          }
          else {
            realValue = this.model[key as string];
          }
        }
        if (realValue) {
          return realValue
        }

        else return

      }
      else
        if (this.model[key as string]) {
          return this.model[key as string]
        }
        else return
    }

  }

}
